import type { IToast } from './toast';

import { faExclamationTriangle } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';

import Description from './components/Description';
import Icon from './components/Icon';
import Title from './components/Title';
import ToastWrapper from './components/ToastWrapper';

/**
 * @example
 * toast(
 *   <ErrorToast
 *     title='Du bist offline.'
 *     description='Bitte überprüfe deine Internetverbindung oder die Einstellungen deiner Firewall'
 *   />,
 *   { type: 'error' }
 * )
 */

const ErrorToast = (props: IToast) => (
  <ToastWrapper>
    <Icon>{props.icon}</Icon>
    <Title>{props.title}</Title>
    <Description>{props.description}</Description>
  </ToastWrapper>
);

ErrorToast.defaultProps = {
  icon: <FontAwesomeIcon icon={faExclamationTriangle} size="lg" />,
};

export default ErrorToast;
